import { Dialog } from '@progress/kendo-react-dialogs'
import './dialog-pdf-viewer.css'

const DialogPdfViewerPure = ({ url, title, onClose }) => {
  return (
    <Dialog width={900} height={750} onClose={onClose} title={title} className="dialog-pdf-viewer">
      <iframe src={url} title={title} className="dialog-pdf-viewer-iframe" />
    </Dialog>
  )
}

export default DialogPdfViewerPure
